export default __webpack_public_path__ + "static/media/riceCrackers.a51a4fb1.jpg";